import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m1.195-14.016a1.21 1.21 0 0 0-1.203-1.19 1.21 1.21 0 0 0-1.205 1.19c0 .658.547 1.204 1.204 1.204.659 0 1.204-.546 1.204-1.204m-.21 2.142h-1.973V17h1.973z",
      clipRule: "evenodd"
    }
  )
);
var SvgInformationFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InformationFilled_default = SvgInformationFilled;

export { InformationFilled_default as default };
